import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const RedirectInvoiceDetails = (props: GridCellProps) => {
  const field = props.field || '';
  const data = props.dataItem[field];
  const { getUrl, redirect } = useRedirect();

  const handleClick = useCallback(() => {
    redirect(
      getUrl('invoiceDetails')(String(props.dataItem.receiptId), String(props.dataItem.poId))
    );
  }, [getUrl, props.dataItem.poId, props.dataItem.receiptId, redirect]);

  return (
    <GridCellBase {...props} title={data} rowSelectionEnabled={true}>
      <button className="cursor-pointer text-link underline" onClick={handleClick}>
        {data ? data : 'Unassigned'}
      </button>
    </GridCellBase>
  );
};

export default RedirectInvoiceDetails;
